export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT = 3;
export const RES_PER_PAGE = 10;
export const KEY = '05cf37df-09a3-41c9-9dee-8e04824f1325';
export const MODAL_CLOSE_SEC = 2.5;
